export const getDirectAppointmentAvailabilityState = (response) => {
  var cautionMessage =
    (response && response.data && response.data.caution && response.data.caution.message) ||
    (response && response.externalInfo && response.externalInfo.warning) ||
    "";

  return {
    allowButton: true,
    info: ["Slot is Available"],
    colorType: "bg-green",
    warningMessage: cautionMessage,
    mediumDate: (response && response.data && response.data.medium && response.data.medium.date) || "",
    clientTimer: (response && response.data && response.data.medium && response.data.medium.time) || "",
  };
};
